import PageLogin from "./PageLogin.vue";
export default PageLogin;
